import axios from './api';
import { getQueryData, getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/templates';
const endPointV1 = getUrl('backend') + '/api/v1/templates';

export const getProjectTemplate = ({ supplier }) =>
  axios
    .get(endPoint.concat('/supplier/', supplier), {
      timeout: 10000,
    })
    .then((res) => res)
    .catch((error) => error.response);

export const getProjectTemplates = async ({ page, size, sort, filters }) => {
  return axios
    .get(endPoint.concat('/', getQueryData(page, size, filters)))
    .then((res) => {
      return { ...res, data: { ...res.data, templates: res.data.data } };
    })
    .catch((error) => {
      return error.response;
    });
};

export const getProjectTemplateById = ({ id }) =>
  axios.get(endPoint.concat('/', id), {
    timeout: 10000,
  });

export const createProjectTemplate = async (template) =>
  axios.post(endPointV1.concat('/'), template, {});

export const updateProjectTemplate = (template) =>
  axios.put(endPointV1.concat('/', template.id), template, {});

export const deleteProjectTemplate = (id) =>
  axios
    .delete(endPoint.concat('/', id), {})
    .then((res) => res)
    .catch((error) => error.response);
